import * as React from 'react';
import Link from '../../../Link';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../../context';
import { CdnIcon } from '@shared/ui';

interface Props {
	service: 'baggage' | 'meal' | 'seat' | 'extras';
}

const Disclaimer: React.FC<Props> = ({ service }) => {
	const css = useTheme('AdditionalServiceBanner').AdditionalServiceBannerStyles;
	const { t } = useTranslation();
	const {
		global: { companyInfo }
	} = useConfig();

	let link: string;

	switch (service) {
		case 'baggage':
			link = companyInfo.baggage && `${companyInfo.baggage}`;
			break;
		case 'meal':
			link = companyInfo.meal && `${companyInfo.meal}`;
			break;
		case 'seat':
			link = companyInfo.seat && `${companyInfo.seat}`;
			break;
	}

	return link ? (
		<div className={css.disclaimer}>
			<Link target="_blank" action={link}>
				<CdnIcon className={css.disclaimer__icon} icon={'Info/Details'} />
				{service === 'meal' && t('MealService:Terms & conditions')}
				{service === 'baggage' && t('BaggagePage:Baggage rules')}
				{service === 'seat' && t('SeatMap:Terms & conditions')}
			</Link>
		</div>
	) : null;
};

export default Disclaimer;
